import { showToast } from '../Toast';

export type AppToastType = 'success' | 'error' | 'info';

export const showAppToast = (message: string, type: AppToastType = 'info') => {
  showToast(message, type === 'info' ? 'success' : type);
};
